import { render } from "./KnowledgebaseView.vue?vue&type=template&id=6343bb42"
import script from "./KnowledgebaseView.vue?vue&type=script&lang=js"
export * from "./KnowledgebaseView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__